"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockcarsStoreClass = void 0;
const redux_1 = require("redux");
const reducers_1 = require("./reducers");
const stateFreezer_1 = require("./reducerEnhancers/stateFreezer");
const middleware_1 = require("./middleware");
const storeObserver_1 = require("./utils/storeObserver");
const dom_1 = require("./utils/dom");
const localStoreRedux_1 = require("./persistence/localStoreRedux");
const sessionStoreRedux_1 = require("./persistence/sessionStoreRedux");
class StockcarsStoreClass {
    constructor(marketPath, startPage) {
        this.sessionStoreRedux = new sessionStoreRedux_1.SessionStoreRedux(`VTP_SESSION_${marketPath}_${startPage}`);
        this.localStoreRedux = new localStoreRedux_1.LocalStoreRedux(`VTP_${marketPath}_${startPage}`);
        this.store = this.configureStore(this.restorePreviousStateFromStorage());
        this.store.subscribe((0, dom_1.throttle)(this.persistStateFn.bind(this), 500));
    }
    static getInstance(marketPath, scsStartPage) {
        if (typeof window !== 'undefined') {
            window.stockcars = window.stockcars || {};
            if (window.stockcars.STCK_STORE) {
                return window.stockcars.STCK_STORE;
            }
            window.stockcars.STCK_STORE = new StockcarsStoreClass(marketPath, scsStartPage);
            return window.stockcars.STCK_STORE;
        }
        return new StockcarsStoreClass(marketPath, scsStartPage);
    }
    get state() {
        return this.store.getState();
    }
    dump() {
        return JSON.stringify(this.store.getState());
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    restorePreviousStateFromStorage() {
        const previousStateFromSession = this.sessionStoreRedux.getSessionState();
        const previousStateFromLocalStorage = this.localStoreRedux.getLocalState();
        const previousState = Object.assign(Object.assign({}, previousStateFromSession), previousStateFromLocalStorage);
        return previousState;
    }
    configureStore(restoredState = {}) {
        const middlewares = [...middleware_1.featureMiddlewares, ...middleware_1.coreMiddlewares];
        const middlewareEnhancer = (0, redux_1.applyMiddleware)(...middlewares);
        const enhancers = [middlewareEnhancer];
        const composedEnhancers = (0, redux_1.compose)(...enhancers);
        const rootReducer = (0, stateFreezer_1.stateFreezer)(reducers_1.rootReducer);
        return (0, redux_1.createStore)(rootReducer, restoredState, composedEnhancers);
    }
    observeStateFromStore(selectorFn, onChange) {
        return (0, storeObserver_1.observeStore)(this.store, selectorFn, onChange);
    }
    waitForStateFromStorePromise({ conditionFn, timeOut = 7000, selectorToReturn = (arg) => true, stateGetterFn = this.store.getState, store = this.store, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let unsubScribe;
                const checkIfConditionMatches = () => {
                    if (conditionFn(stateGetterFn())) {
                        if (typeof unsubScribe === 'function') {
                            unsubScribe();
                        }
                        resolve(selectorToReturn(stateGetterFn()));
                    }
                };
                checkIfConditionMatches();
                unsubScribe = store.subscribe(checkIfConditionMatches);
                setTimeout(() => reject(new Error('waited too long for selector´s state to match the condition.')), timeOut);
            });
        });
    }
    persistStateFn() {
        this.sessionStoreRedux.saveSessionState(this.store.getState());
        this.localStoreRedux.saveLocalState(this.store.getState());
    }
}
exports.StockcarsStoreClass = StockcarsStoreClass;
//# sourceMappingURL=store.js.map